type Props = {
  label: string;
  detail?: string;
};

/** Banner di attesa con spinner — usarlo in ogni operazione lunga. */
export function ProgressBanner({ label, detail }: Props) {
  return (
    <div className="progress-banner" role="status" aria-live="polite">
      <span className="spinner" aria-hidden />
      <div className="progress-text">
        <strong>{label}</strong>
        {detail ? <span>{detail}</span> : null}
      </div>
    </div>
  );
}
